const get = require('lodash/get')
const findLast = require('lodash/findLast')

const { locationIdToProperties } = require('../../tools/location-id-to-properties')

const DEFAULT_LOCATION_ID_HIERARCHY = ['country', 'zone', 'state', 'lga', 'sdp']

const getRegionLevelSubTiers = (location, searchQuery = null, config) => {
  // Get location's country. We assume Nigeria if location indicates no country
  // just because we started in Nigeria so there was no need to indicate the location's country back then
  // For the same reason, we default to Nigeria administrative boundaries if they're not part of the configuration
  const locationProps = locationIdToProperties(location)
  const hierarchy = get(config, `perCountryLocationIdHierarchy.${locationProps.country}`) || DEFAULT_LOCATION_ID_HIERARCHY
  // Analytics doesn't recognise the SDP level as a sub-tier so we remove it from the hierarchy
  const hierarchyWithoutSdp = hierarchy.slice(0, hierarchy.indexOf('sdp'))

  delete locationProps.id
  delete locationProps.level
  const locationLevels = Object.keys(locationProps)
  // Now let's find the highest level in the hierarchyWithoutSdp present in locationLevels
  const currentLevel = findLast(hierarchyWithoutSdp, level => locationLevels.includes(level))
  if (!currentLevel) {
    throw new Error(`Invalid location: No known hierarchyWithoutSdp level found in "${location}"`)
  }

  const locationIndex = hierarchyWithoutSdp.indexOf(currentLevel)

  // Determine sub-tiers based on the hierarchyWithoutSdp
  const startIndex = locationIndex + (searchQuery ? 0 : 1)
  const subTiers = hierarchyWithoutSdp.slice(startIndex, startIndex + 2)
  return subTiers
}

module.exports = {
  getRegionLevelSubTiers,
  DEFAULT_LOCATION_ID_HIERARCHY
}
